"use client";

import Link from "next/link";
import React, { cache, Suspense, useEffect, useState } from "react";
import MenuBar from "../menu/menu";
import SearchBar from "../common/SearchBar";
import MaxWidthWrapper from "../MaxWithWrapper";
import { Heart, NotebookPen } from "lucide-react";
import MyAccountDropDown from "../common/MyAccountDropDown";
import * as apiService from "@/src/service/apiService";
import NavItems from "./NavItems";
import { Heading } from "../common/Heading";
import Image from "next/image";
import { useDispatch } from "react-redux";
import {
  setBlogCategories,
  setProductCategories,
  setToolsCategories,
} from "@/src/redux/slices/categoryMenu";
// import NavItem1 from "./NavItem1";

import { usePathname } from "next/navigation";
import { Utility } from "@/src/utils/utility";
import { RouteEnum } from "@/src/utils/constant";
import { set } from "zod";

// const LottiePlayer = dynamic(() => import("lottie-react").then((mod) => mod), {
//   ssr: false,
// });

//reduplicate request if not using fetch
const getCategory = cache(async (slug?: string) => {
  // const response = await fetch(apiService.fetchCategoryString(slug), {
  //     next: { revalidate: 86400 }, // Revalidate after one day (86400 seconds)
  // });
  const response = await fetch(apiService.fetchAllMenuCategory(), {
    next: { revalidate: 86400 }, // Revalidate after one day (86400 seconds)
  });

  if (!response.ok) {
    return null;
  }

  const data = await response.json();
  return data;
});

const getBlogCategory = cache(async (slug?: string) => {
  // const response = await fetch(apiService.fetchCategoryString(slug), {
  //     next: { revalidate: 86400 }, // Revalidate after one day (86400 seconds)
  // });
  const response = await fetch(apiService.fetchAllBlogMenuCategory(), {
    next: { revalidate: 86400 }, // Revalidate after one day (86400 seconds)
  });

  if (!response.ok) {
    return null;
  }

  const data = await response.json();
  return data;
});

const getToolsCategory = cache(async (slug?: string) => {
  // const response = await fetch(apiService.fetchCategoryString(slug), {
  //     next: { revalidate: 86400 }, // Revalidate after one day (86400 seconds)
  // });
  const response = await fetch(apiService.fetchAllToolsMenuCategory(), {
    next: { revalidate: 86400 }, // Revalidate after one day (86400 seconds)
  });

  if (!response.ok) {
    return null;
  }

  const data = await response.json();
  return data;
});

export default function Navbar() {
  // const pathname = usePathname();
  // const params = useSearchParams();

  const pathname = usePathname();
  // const isBlogRoute = pathname.startsWith("/blog");
  const currentPlatformRoute = Utility.getRouterPlatformName(pathname);

  const [category, setCategory] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(true);

  //REDUX STORING AL CATEGORY
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (currentPlatformRoute === RouteEnum.BLOG) {
          const blogCategory = await getBlogCategory();
          setCategory(blogCategory?.data);
          dispatch(setBlogCategories(blogCategory?.data ?? []));
        } else if (currentPlatformRoute === RouteEnum.TOOLS) {
          //validate for tools
          const toolsCategory = await getToolsCategory();
          setCategory(toolsCategory?.data);
          dispatch(setToolsCategories(toolsCategory?.data ?? []));
        } else {
          const category = await getCategory();
          setCategory(category?.data);
          dispatch(setProductCategories(category?.data ?? []));
        }
      } catch (error) {
        console.error(error);
      }
      setCategoryLoading(false);
    };

    fetchData();
  }, []);

  return (
    <Suspense>
      <header
        // className='sticky top-0 z-50 bg-white'
        className="bg-white text-black"
      >
        <MaxWidthWrapper>
          <nav
            // className=" py-5 px-4 md:px-8 lg:px-16 xl:px-32 2xl:px-64 border-b-2"
            className="relative md:pt-5"
          >
            {/* MOBILE */}
            <div className="mx-5 mb-5 flex flex-col md:hidden">
              <div className="flex w-full items-center justify-between py-4">
                <div className="flex items-center gap-2">
                  <Link
                    href={Utility.getRouteLinkUrl({
                      main: "/",
                      blog: "/blog",
                      tools: "/tools",
                      pathname: pathname,
                    })}
                  >
                    <Heading as="h1">Starlightopia</Heading>
                  </Link>
                  <Image
                    src="/image/logo.png"
                    alt="logo"
                    width={50}
                    height={50}
                    priority
                    onContextMenu={(e) => e?.preventDefault()}
                  />
                </div>

                {/* LIST OF ICONS AND DROP DOWN */}
                <div className="flex items-center justify-end gap-3">
                  <Link
                    href={"/blog"}
                    className="flex flex-col items-center gap-1 text-black"
                    aria-label="View best blog posts"
                  >
                    <div className="cursor-pointer font-light hover:text-main-default">
                      <NotebookPen className="sm:h-7 sm:w-7" />
                    </div>
                  </Link>
                  <MyAccountDropDown />
                  <Link
                    href={"/u/favourites"}
                    className="flex flex-col items-center gap-1 text-black"
                    aria-label="View your favourites"
                  >
                    <div className="cursor-pointer font-light hover:text-main-default">
                      <Heart className="sm:h-7 sm:w-7" />
                    </div>
                  </Link>
                  <MenuBar
                    category={category}
                    categoryLoading={categoryLoading}
                  />
                </div>
              </div>

              {/* RIGHT */}
              <div className="flex items-center justify-center sm:mx-28">
                <SearchBar />
              </div>
            </div>

            {/* BIGGER SCREENS */}
            <div className="hidden h-full items-center justify-between gap-8 px-10 md:flex">
              {/* LEFT */}
              {/* Xl - is tablet screen */}

              <div className="flex w-1/3 items-center gap-2">
                <Link
                  // href={"/"}
                  href={Utility.getRouteLinkUrl({
                    main: "/",
                    blog: "/blog",
                    tools: "/tools",
                    pathname: pathname,
                  })}
                >
                  {/* <div className='font-bold tracking-wide uppercase'>Starlightopia</div> */}
                  <Heading>Starlightopia</Heading>
                </Link>

                {/* <LottiePlayer
                  animationData={CAT_DANCE_JSON}
                  loop
                  className="h-16 w-16"
                /> */}

                <Image
                  src="/image/logo.png"
                  alt="logo"
                  width={50}
                  height={50}
                  priority
                  onContextMenu={(e) => e?.preventDefault()}
                />
              </div>

              {/* RIGHT */}
              <div className="flex w-2/3 items-center justify-between gap-8 xl:w-1/3">
                <SearchBar />
              </div>

              {/* LIST OF ICONS AND DROP DOWN */}
              <div className="flex w-1/3 items-center justify-end gap-3">
                <Link
                  href={"/blog"}
                  className="flex flex-col items-center gap-1 text-black"
                  aria-label="View best blog posts"
                >
                  <div className="cursor-pointer font-light hover:text-main-default">
                    <NotebookPen className="h-6 w-6 text-gray-600" />
                  </div>
                  <div className="text-nowrap text-xs font-light">Blog</div>
                </Link>

                <MyAccountDropDown />
                <Link
                  href={"/u/favourites"}
                  className="flex flex-col items-center gap-1 text-black"
                  aria-label="View your favorites"
                >
                  <div className="cursor-pointer font-light hover:text-main-default">
                    <Heart className="h-6 w-6" />
                  </div>
                  <div className="text-nowrap text-xs font-light">
                    Favorites
                  </div>
                </Link>
              </div>
            </div>

            <NavItems category={category} categoryLoading={categoryLoading} />

            {/* <div className="flex justify-center pt-5 pb-5">
              <NavItem1 category={category} />
            </div> */}
            <div className="border-b"></div>
          </nav>
        </MaxWidthWrapper>

        {/* BACK_BUTTON */}
        {/* <div className={`${links.some((e) => e?.href === pathname) ? "hidden" : "block"} px-4 md:px-8 lg:px-16 xl:px-32 2xl:px-64 mt-4`} >
                <BackButton />
            </div> */}
      </header>
    </Suspense>
  );
}
